import React from 'react';

import Icons from 'assets/icons';

const relativeToLastYearSymbols = {
  Increase: <Icons.ArrowUp />,
  Decrease: <Icons.ArrowDown />,
  Maintain: <Icons.Maintain />,
};

const relativeToLastYearClasses = {
  Increase: 'text-success-06',
  Decrease: 'text-red-04',
  Maintain: 'text-gray-04',
};

const subFieldsClasses =
  'bg-gray-06 group-aria-selected:bg-navy-01 py-1 px-1.5 rounded';

const renderIcon = (element) => (
  <span
    aria-label={element.relativeToLastYear}
    className={relativeToLastYearClasses[element.relativeToLastYear]}
  >
    {relativeToLastYearSymbols[element.relativeToLastYear]}
  </span>
);

const renderSubArea = (detail) => {
  if (!detail.subArea) return null;

  return <span className={subFieldsClasses}>{detail.subArea}</span>;
};

const getOptionsText = (options) => {
  if (!options || !Array.isArray(options)) return '';

  return options.join(', ');
};

const renderDetailContent = (detail) => {
  const parts = [];

  if (detail.focusArea) {
    parts.push(detail.focusArea);
  }

  if (detail.options && detail.options.length) {
    parts.push(getOptionsText(detail.options));
  }

  return parts.length ? (
    <span className="break-words">{parts.join(' - ')}</span>
  ) : null;
};

export const renderCriticalElement = (element) => {
  if (!element) return null;

  return (
    <div className="flex flex-wrap">
      <div className="flex flex-wrap items-center gap-1 break-words">
        <>
          <span
            className={relativeToLastYearClasses[element.relativeToLastYear]}
          >
            {element.stage} {element.metric}
          </span>
          {renderIcon(element)}
        </>

        {element.details &&
          element.details.map((item, detailIndex) => (
            <React.Fragment key={item.id || detailIndex}>
              {renderSubArea(item)}
              <div className="flex flex-wrap items-center">
                {renderDetailContent(item)}
              </div>
              {detailIndex !== element.details.length - 1 && (
                <Icons.PlusInCircle
                  className="h-4 w-4 text-gray-04"
                  aria-hidden="true"
                />
              )}
            </React.Fragment>
          ))}

        {element.summary && (
          <span className="font-normal text-gray-04">{element.summary}</span>
        )}
      </div>
    </div>
  );
};
